import { Card, Spin } from "antd";
import AdminLayout from "components/layouts/AdminLayout";
import { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { Link } from "react-router-dom";
import { TranslateString } from "Utils/Common";

const OneLoanQuotationLayout = (props: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loading, setLoading] = useState<boolean>(false);

    return (
        <>
            <AdminLayout>
                <Spin spinning={loading}>
                    <div className="ant-card ant-card-bordered cu-mb-10 cu-px-10 w-100 text-left">
                        <Link to={`/housingcompany`}>
                            <h4 className="cu-m-0 cu-p-0">
                                <button className="ant-btn cu-border-0 cu-btn"><FaArrowLeft style={{ fontWeight: 900, fontSize: '18px' }} /></button>
                                &nbsp;
                                <button className="ant-btn cu-border-0 cu-btn h4">{TranslateString('one_loan_quotation')}</button>
                            </h4>
                        </Link>
                    </div>
                    <Card className="cu-table-small">
                        <div className='mt-4 cu-table-scroll cu-table-border' style={{ "height": "" }}>
                            <table className="table table-sm table-bordered table-striped" >
                                <thead className="cu-bg-subgreen">
                                    <tr className="cu-bg-green">
                                        <td colSpan={13} className='text-left cu-text-large fw-bold'>
                                            <div className='ms-2'>{TranslateString('open_loan_tendering_case')}</div>
                                        </td>
                                    </tr>
                                    <tr className='cu-bg-subgreen align-top'>
                                        <th scope="col" className='text-left'>{TranslateString('quotation_submit_time')}</th>
                                        <th scope="col" className='text-left'>{TranslateString('bank')}</th>
                                        <th scope="col" className='text-left'>{TranslateString('documents')}</th>
                                        <th scope="col" className='text-left'>{TranslateString('quotation_received_and_valid_until')}</th>
                                        <th scope="col" className='text-left'>{TranslateString('margin')}</th>
                                        <th scope="col" className='text-left'>{TranslateString('payments_per_year')}</th>
                                        <th scope="col" className='text-left'>{TranslateString('interest_base')}</th>
                                        <th scope="col" className='text-left'>{TranslateString('loan_span')}</th>
                                        <th scope="col" className='text-left'>{TranslateString('capital')}</th>
                                        <th scope="col" className='text-left'>{TranslateString('downpayment_type')}</th>
                                        <th scope="col" className='text-left'>{TranslateString('sanction')}</th>
                                        <th scope="col" className='text-left'>{TranslateString('fee')}</th>
                                        <th scope="col" className='text-left'>{TranslateString('document')}</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {<>
                                        <tr className='text-left' key={Math.random()}>
                                            <td >{"9.10.2022 Klo 14:00"}</td>
                                            <td >{"Bank 1"}</td>
                                            <td >{<Link to="/">Link</Link>}</td>
                                            <td className="text-danger">{"9.10.2022"}</td>
                                            <td >{"0.7"}</td>
                                            <td >{"1"}</td>
                                            <td >{"Euribor 12"}</td>
                                            <td >{"20"}</td>
                                            <td>{"1000000€"}</td>
                                            <td>{"Tasaera"}</td>
                                            <td>{"1% "}</td>
                                            <td>{"0,50%"}</td>
                                            <td>{<Link to="/">Open</Link>}</td>
                                        </tr>
                                        <tr className='text-left' key={Math.random()}>
                                            <td >{"9.10.2022 Klo 14:00"}</td>
                                            <td >{"Bank 1"}</td>
                                            <td >{<Link to="/">Link</Link>}</td>
                                            <td className="text-danger">{"9.10.2022"}</td>
                                            <td >{"0.7"}</td>
                                            <td >{"1"}</td>
                                            <td >{"Euribor 12"}</td>
                                            <td >{"20"}</td>
                                            <td>{"1000000€"}</td>
                                            <td>{"Tasaera"}</td>
                                            <td>{"1% "}</td>
                                            <td>{"0,50%"}</td>
                                            <td>{<Link to="/">Open</Link>}</td>
                                        </tr>
                                    </>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Card>
                </Spin>
            </AdminLayout>
        </>
    );
};
export default OneLoanQuotationLayout;